
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/minerals/[slug]",
      function () {
        return require("private-next-pages/minerals/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/minerals/[slug]"])
      });
    }
  